import {camelizeKeys, decamelizeKeys} from "humps";

export default {
  /**
   * This endpoint will email the info for the given exception to the development team.
   * @param {Error} error - The exception to send.
   * @param {ErrorInfo} [reactErrorInfo] - React stack information.
   * @returns {Promise<?Object>}
   */
  sendException(error, reactErrorInfo) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/app_logging/send_exception",
        type: "POST",
        data: decamelizeKeys({ exceptionMessage: error.message, stackTrace: error.stack + "\n\n" + (reactErrorInfo ? reactErrorInfo.componentStack : "") }),
        success: response => resolve(camelizeKeys(response)),
        error: response => reject(response.responseJSON)
      });
    });
  }
};
